module.exports = __webpack_public_path__ + "img/Pisum_sativum.d2d94e24.jpg";